import { Textarea } from "@/components/ui/textarea";
export const ChatInputEditor = ({
  value,
  onChange,
  onKeyDown,
  disabled,
  ref,
  isStreaming,
}: {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onKeyDown: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
  disabled: boolean;
  ref: React.RefObject<HTMLTextAreaElement | null>;
  isStreaming: boolean;
}) => {
  return (
    <div className="bg-background">
      <Textarea
        ref={ref}
        placeholder={isStreaming ? "Waiting for response..." : "Ask Anything"}
        className="shadow-none min-h-[24px] max-h-[160px] bg-transparent dark:bg-transparent h-12 w-full rounded-3xl border-0 focus-visible:ring-0 focus-visible:ring-offset-0 text-base pl-2 pr-4 pt-1 pb-0 resize-none overflow-y-auto leading-tight"
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        onFocus={() => {
          // Ensure the textarea is scrolled into view when focused
          if (ref.current) {
            ref.current.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }
        }}
        disabled={isStreaming}
      />
    </div>
  );
};
